module.exports = __webpack_public_path__ + "img/skinbox-sale-small.0e48334d.png";